import { select, takeLatest, put } from 'redux-saga/effects';
import { push, replace } from 'connected-react-router';
import qs from 'query-string';

import * as actions from './actions';
import { selectPathname, selectSearchParams } from './selectors';

function* updateQueryString({ payload }) {
  const { pathname, replaceHistory, ...rest } = payload;
  const currentPath = yield select(selectPathname);
  const existingSearch = yield select(selectSearchParams);

  const updatedSearch = qs.stringify({
    ...existingSearch,
    ...rest,
  });

  const p = pathname || currentPath;
  const url = `${p}?${updatedSearch}`;

  const action = replaceHistory ? replace : push;

  yield put(action(url));
}

export function* watchUpdateQueryString() {
  yield takeLatest(actions.UPDATE_QUERYSTRING, updateQueryString);
}
